import {Component, input, InputSignal} from '@angular/core';

@Component({
  selector: 'icon-calendar',
  imports: [],
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" [attr.width]="size()" [attr.height]="size()" viewBox="0 0 24 24">
      <path fill="currentColor" fill-rule="evenodd"
            d="M6 1a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V2a1 1 0 0 1 1-1Zm12 0a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1Z"
            clip-rule="evenodd" />
      <path fill="currentColor" fill-rule="evenodd"
            d="M1.75 5.75A2.75 2.75 0 0 1 4.5 3h15a2.75 2.75 0 0 1 2.75 2.75V20a2.75 2.75 0 0 1-2.75 2.75h-15A2.75 2.75
            0 0 1 1.75 20V5.75ZM8 13a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-3a1 1 0 0 1-1-1Zm4 0a1 1 0 0 1 1-1h2a1
            1 0 0 1 .97 1.242l-1 4a1 1 0 1 1-1.94-.485L13.72 14H13a1 1 0 0 1-1-1ZM6 7a1 1 0 0 0 0 2h12a1 1 0 1 0 0-2H6Z"
            clip-rule="evenodd" />
    </svg>
  `,
})
export class IconCalendarComponent {
  size: InputSignal<number> = input<number>(24);
}
